module.exports = __webpack_public_path__ + "images/c828f41d72df836aadb8204480ca7e96-bedroom-style2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/content/bedroom-style2.jpg
// module id = ./src/assets/images/content/bedroom-style2.jpg
// module chunks = 0